import { useEffect } from "react"
import { useLocation } from "react-router"

export function useScrollToAnswerByQuery(scrollDelay: number = 1000) {
  const location = useLocation()
  const query = new URLSearchParams(location.search)
  const urlQueryId = query.get("question")

  useEffect(() => {
    if (urlQueryId) {
      setTimeout(() => {
        const element = document.getElementById(urlQueryId)
        if (element) {
          element.scrollIntoView({ behavior: "smooth" })
        }
      }, scrollDelay)
    }
  }, [urlQueryId, scrollDelay])
}
